import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { IProductCarrierRanking } from '../../models/product-carrier-ranking.model';

export interface ICarrierRankingService {
  /**
   * Retrieves the carrier rankings for each product for the tenant
   */
  getCarrierRankingsForCurrentTenant(): Observable<IProductCarrierRanking[]>;
  /**
   * Updates the carrier rankings with the passed in rankings
   *
   * @param updatedRankings - The new list of rankings
   */
  updateCarrierRankingsForCurrentTenant(
    updatedRankings: IProductCarrierRanking[],
  ): Observable<IProductCarrierRanking[]>;
}

@Injectable({ providedIn: 'root' })
export class CarrierRankingService implements ICarrierRankingService {
  constructor(private http: HttpClient) {}

  getCarrierRankingsForCurrentTenant(): Observable<IProductCarrierRanking[]> {
    const url = `${environment.apiBaseUri}/carrier_rankings_by_products`;
    return this.http.get<IProductCarrierRanking[]>(url);
  }

  updateCarrierRankingsForCurrentTenant(
    updatedRankings: IProductCarrierRanking[],
  ): Observable<IProductCarrierRanking[]> {
    const url = `${environment.apiBaseUri}/carrier_rankings_by_products`;
    return this.http.post<IProductCarrierRanking[]>(url, {
      rankings: updatedRankings,
    });
  }
}
